/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringCriteriaRequest
 */
export interface StringCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof StringCriteriaRequest
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringCriteriaRequest
     */
    exclude?: boolean;
}

export function StringCriteriaRequestFromJSON(json: any): StringCriteriaRequest {
    return StringCriteriaRequestFromJSONTyped(json, false);
}

export function StringCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringCriteriaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function StringCriteriaRequestToJSON(value?: StringCriteriaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'exclude': value.exclude,
    };
}


